import $ from 'jquery';
import Router from 'root/router';
import Cache from 'root/cache';
import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';
import View_User_Data from 'view/user_data';
import Collection_Survey_Question from 'collection/survey_question';
import responseSessionTemplate from 'template/survey/response_session';

export default View.extend({
    className: 'survey-response-sidebar',

    model_index: 0,

    views: {
        user_data: null,
    },

    events: {
        'click .nav-close'  : 'onClose',
        'click .nav-prev'   : 'onPrev',
        'click .nav-next'   : 'onNext',
        'click .user-id'    : 'onViewUser',
        'click .tab-menu a' : 'onTabMenuClick',
        'click .session-replay-watch': 'onSessionReplayWatch'
    },

    dom_handlers: {
        onClose: function(e) {
            this.remove();

            Router.removeQueryString('id', {trigger: false});
        },

        onPrev: function(e) {
            this.model = this.model_list[this.model_index - 1];
            this.model_index--;
            this.render();
        },

        onNext: function(e) {
            this.model = this.model_list[this.model_index + 1];
            this.model_index++;
            this.render();
        },

        onViewUser: function(e) {
            e.preventDefault();

            Modals.openUserIdentification(this.model.get('user_identification'));
        },

        onTabMenuClick: function(e) {
            var tab_name = $(e.currentTarget).attr('href');

            if (tab_name === '#response') {
                this.$el.find('.region-user-info').show();
                this.$el.find('.region-response-details').show();
                this.$el.find('.region-session-details').hide();
                this.$el.find('.region-user-data').hide();
                this.$el.find('.region-custom-data').hide();
            } else {
                this.$el.find('.region-user-info').hide();
                this.$el.find('.region-response-details').hide();
                this.$el.find('.region-session-details').show();
                this.$el.find('.region-user-data').show();
                this.$el.find('.region-custom-data').show();
            }
        },

        onSessionReplayWatch: function(e) {
            Modals.openSessionRecording(this.model.get('session_recording_id'));
        },

        onDocumentKeydown: function(e) {
            var target = $(e.target);

            if (target.is('input, textarea, select')) {
                return;
            }

            if (target.prop('contenteditable') === 'true') {
                return;
            }

            switch (e.keyCode) {
                case 27: // esc
                    this.$el.find('.nav-close').click();
                    break;
                case 38: // up arrow
                    e.preventDefault();
                    this.$el.find('.nav-prev').click();
                    break;
                case 40: // down arrow
                    e.preventDefault();
                    this.$el.find('.nav-next').click();
                    break;
            }
        }
    },

    event_handlers: {
        onBuildPage: function() {
            this.remove();
        }
    },

    initialize: function(options) {
        // when opening a survey response from the current project
        // the question collection is already loaded
        if (this.model.get('project_id') === Cache.default_project_id) {
            this.questions = Cache.survey_question.models.filter((model) => {
                return ['welcome', 'thankyou'].indexOf(model.get('question_type')) === -1;
            });
        }

        this.user_data = options.user_data;
        this.model_list = options.model_list;

        if (this.model_list) {
            this.model_list.forEach((model, index) => {
                if (model.id === this.model.id) {
                    this.model_index = index;
                }
            });
        }

        this.views.user_data = new View_User_Data({
            model: this.model,
            identification : this.model.get('user_identification'),
            sidebar: true,
        });

        Cache.app.dispatcher.on('UI::build_page', this.event_handlers.onBuildPage.bind(this));

        $(document).on('keydown.' + this.cid, this.dom_handlers.onDocumentKeydown.bind(this));

        this.on('remove', () => {
            $(document).off('keydown.' + this.cid);
        });
    },

    // load questions
    load: function() {
        Cache.app.request({
            action: 'survey/loadQuestions',
            data: {
                project_id: this.model.get('project_id')
            },
            success: (response) => {
                var collection = new Collection_Survey_Question(response);
                this.questions = collection.filter((model) => {
                    return ['welcome', 'thankyou'].indexOf(model.get('question_type')) === -1;
                });

                this.render();
            }
        });
    },

    render: function() {
        var user_data = this.user_data[this.model.get('user_identification')] || {};
        var questions = '';

        if (this.questions) {
            this.questions.forEach((question) => {
                questions +=
                '<div>' +
                    '<div class="margin-bottom-4 text-info">' + question.getLabel(true) + '</div>' +
                    '<div>' + (this.model.renderAnswer(question, true) || '-') + '</div>' +
                '</div>';
            });
        }

        var custom_data = this.model.get('custom_data');
        var custom_data_items = '';

        Object.entries(custom_data).forEach(([label, data]) => {
            custom_data_items +=
            '<div class="title" title="' + Util.htmlEntities(label) + '">' + Util.htmlEntitiesWithA(label) + ':</div>' +
            '<div class="value">' + (Util.htmlEntitiesWithA(data, true) || '-') + '</div>';
        });

        var content =
        '<div class="layout-header">' +
            '<div class="region-nav">' +
                (this.model_list ?
                '<button type="button" class="nav-prev"><i class="fa-regular fa-angle-up"></i></button>' +
                '<button type="button" class="nav-next"><i class="fa-regular fa-angle-down"></i></button>' : '') +
                '<button type="button" class="nav-close"><i class="fa-regular fa-xmark"></i></button>' +
            '</div>' +

            '<div class="region-heading">' +
                '<div class="badge-id">' + this.model.id  + '</div>' +
                '<div class="survey-title">' + Util.moment(this.model.get('create_time'), 'DD MMM YYYY', false, false) + '</div>' +
            '</div>' +

            '<div class="region-tabs">' +
                '<div class="tab">' +
                    '<div class="tab-menu">' +
                        '<a href="#response" class="active">Response</a>' +
                        '<a href="#session">Session</a>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +

        '<div class="layout-body">' +

        (this.questions ?

        (this.model.get('user_identification') ?
        '<div class="region-user-info font-weight-medium">' +
            '<a href="#" class="user-id no-underline">' +
            (user_data.display_name || user_data.email || '<span class="badge-id">' + this.model.escape('user_identification') + '</span>') +
            ' <i class="fa-solid fa-badge-check text-primary"></i>' +
            '</a>' +
        '</div>' : '') +

        '<div class="region-response-details box-neutral-light"><div class="grid-gap-16">' + questions + '</div></div>' +

        '<div class="region-session-details" style="display:none;">' +
            '<div class="item-header">Metadata</div>' +
            '<div class="session-data-panel box-neutral-light">' +
                responseSessionTemplate(this.model) +
            '</div>' +
        '</div>' +

        '<div class="region-user-data" style="display: none"></div>' +

        '<div class="region-custom-data" style="display:none;">' +
            '<div class="item-header">Custom Data</div>' +
            '<div class="custom-data-panel box-neutral-light">' +
                (custom_data_items ?
                '<div class="item-content">' + custom_data_items + '<div>' :
                '<div class="text-info italic">No custom data captured. <a target="help" rel="noopener" href="https://docs.userback.io/docs/attach-custom-data">Find out more</a>.</div>') +
            '</div>' +
        '</div>' +

        (this.model.get('session_recording_id') ?
        '<div class="session-replay-watch"><i class="fa-solid fa-circle-play"></i> Session Replay</div>' : '')

        :

        '<div class="loader-placeholder"></div>' +
        '<div class="loader-placeholder margin-top-8" style="width:70%;"></div>');

        this.$el.html(content);

        if (!this.questions) {
            this.load();
        }

        if (this.model_list) {
            if (this.model_index === 0) {
                this.$el.find('.nav-prev').prop('disabled', true);
            }

            if (this.model_index === this.model_list.length - 1) {
                this.$el.find('.nav-next').prop('disabled', true);
            }
        }

        if (this.views.user_data) {
            this.views.user_data.render().$el.appendTo(this.$el.find('.region-user-data'));
        }

        return this;
    }
});